import { SpinnerProps } from './Spinner.types';
import { cn } from '@/app/lib/utils';
import { SpinnerIcon } from '@workspace/assets/icons';

const Spinner: React.FC<SpinnerProps> = ({ size = 'small', className }) => {
  const sizeClasses = {
    small: 'w-6 h-6', // 24x24px
    large: 'w-12 h-12', // 48x48px
  };

  const iconSize = size === 'small' ? 24 : 48;

  return (
    <div className={cn('inline-block animate-spin', sizeClasses[size], className)} role="status" aria-label="Loading">
      <SpinnerIcon height={iconSize} width={iconSize} className="w-full h-full" color="currentColor" />
    </div>
  );
};

export default Spinner;
